@if (dateValue(); as date) {
  <div class="crm-date-cell">
    {{ date | date: "mediumDate":"+0000" }}
  </div>
} @else {
  <glxy-blank-value></glxy-blank-value>
}
